import { RequestStatus } from '@/pages/avatar/common';
import { useAnalytics } from '@/services/analytics';
import { NotificationTopics, useNotifications } from '@/services/notification/notificationProvider';
import { MixPanelEvent } from '@/utils/types';
import { useEffect } from 'react';
import { useCreateAvatarStore } from '../common/context';

export const useConsentNotifications = (consentStatusHandler?: (consentId: string, status: RequestStatus) => any) => {
    const { subscribe, unsubscribe } = useNotifications();
    const mixpanel = useAnalytics();
    const createAvatarStore = useCreateAvatarStore();

    useEffect(() => {
        const subscriptionId = subscribe(NotificationTopics.consents, async (event: MessageEvent) => {
            try {
                const parsedMessage = JSON.parse(event.data);

                const subject = parsedMessage.messageAttributes.subject.stringValue;
                const consentId = parsedMessage.body.id;
                const status = subject?.split('/')?.[1];

                if (status === 'done') {
                    mixpanel?.track('avatar-consent', {
                        type: 'record',
                        language: createAvatarStore.consentLanguage,
                        event: MixPanelEvent.SUCCESS,
                    });
                    consentStatusHandler?.(consentId, RequestStatus.SUCCESS);
                }

                if (status === 'error') {
                    mixpanel?.track('avatar-consent', {
                        type: 'record',
                        language: createAvatarStore.consentLanguage,
                        event: MixPanelEvent.ERROR,
                    });
                    consentStatusHandler?.(consentId, RequestStatus.ERROR);
                }
            } catch {}
        });

        return () => {
            unsubscribe(NotificationTopics.consents, subscriptionId);
        };
    }, []);
};
